var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-310, -143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(314, 152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,19 C22.0081289,19 29,19 29,18 C29,10.2477462 22.5081289,3.96330275 14.5,3.96330275 C6.49187113,3.96330275 0,10.2477462 0,18 C0,19 5.99187113,19 14,19 Z",
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#0E1C39",
    cx: 8.13137255,
    cy: 11.5045872,
    rx: 1.42156863,
    ry: 1.37614679
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#0E1C39",
    cx: 20.9823529,
    cy: 11.5045872,
    rx: 1.42156863,
    ry: 1.37614679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.91372549,
    y1: 0,
    x2: 9.09803922,
    y2: 4.95412844,
    id: "\\u8DEF\\u5F84-3",
    stroke: "#0E1C39",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.1294118,
    y1: 0,
    x2: 23.2,
    y2: 4.95412844,
    id: "\\u8DEF\\u5F84-3",
    stroke: "#0E1C39",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.6647, 2.4771) scale(-1, 1) translate(-21.6647, -2.4771)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAndroid);
export default __webpack_public_path__ + "static/media/icon_android.430f462aec394b051e139f13247f5cf5.svg";
export { ForwardRef as ReactComponent };